module.exports = __webpack_public_path__ + "img/icon-close.a5d1c7be.svg";